var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Col, Row } from "react-bootstrap";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import Clientprofilecard from "@frameworks/shared-library/components/Clientprofilecard";
import EliteProgram from "./EliteProgram";
import RelationShipHistory from "./RelationShipHistory";
import di from "../../di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "../../../../../../shared-library/components/Loader";
import ClientHeader from "../../ClientHeader/ClientHeader";
var ClientOwners = function () {
    var _a, _b, _c, _d;
    var _e = __read(React.useState(false), 2), loader = _e[0], setLoader = _e[1];
    var _f = __read(React.useState(), 2), clientData = _f[0], setClientData = _f[1];
    var selectedAcount = useSelector(function (state) { return state.Clients.ClientSearch.reducersData.selected; });
    var getOwners = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoader(true);
                    return [4 /*yield*/, di.clients.getOwnersInformation({
                            Accode: selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode,
                        })];
                case 1:
                    response = _a.sent();
                    setClientData(response);
                    setLoader(false);
                    return [2 /*return*/];
            }
        });
    }); };
    React.useEffect(function () {
        if (selectedAcount && (selectedAcount === null || selectedAcount === void 0 ? void 0 : selectedAcount.accountCode))
            getOwners();
    }, [selectedAcount]);
    return (React.createElement("div", null, loader ? (React.createElement("div", { className: "position-relative client-loader" },
        React.createElement(Loader, null))) : (React.createElement(React.Fragment, null,
        React.createElement(ClientHeader, null),
        React.createElement(GridContainer, { parentClass: "px-0 client-ownersblock" },
            React.createElement("section", { className: "section-padding", id: "client-owners" },
                React.createElement(Row, { className: "Headblock mx-0 DMSanBold_18_700 txt_blackOne1" }, "Client Owners"),
                React.createElement(Row, { className: "mx-0 client-owners-card-block" },
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { data: clientData === null || clientData === void 0 ? void 0 : clientData.salesAgent, employeecode: 0, sincetime: "", designation: "Sales Agent" })),
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "Client Owner", data: clientData === null || clientData === void 0 ? void 0 : clientData.clientOwner })),
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "Equity Advisor", data: clientData === null || clientData === void 0 ? void 0 : clientData.eqAdvisor })),
                    React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "CXO", data: clientData === null || clientData === void 0 ? void 0 : clientData.cxo })),
                    !!(clientData === null || clientData === void 0 ? void 0 : clientData.wealthRM) &&
                        (clientData === null || clientData === void 0 ? void 0 : clientData.wealthRM) &&
                        ((_a = clientData === null || clientData === void 0 ? void 0 : clientData.wealthRM) === null || _a === void 0 ? void 0 : _a.name) !== "" && (React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "Wealth RM", data: clientData === null || clientData === void 0 ? void 0 : clientData.wealthRM }))),
                    !!(clientData === null || clientData === void 0 ? void 0 : clientData.esopRM) &&
                        (clientData === null || clientData === void 0 ? void 0 : clientData.esopRM) &&
                        ((_b = clientData === null || clientData === void 0 ? void 0 : clientData.esopRM) === null || _b === void 0 ? void 0 : _b.name) !== "" && (React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "ESOP RM", data: clientData === null || clientData === void 0 ? void 0 : clientData.esopRM }))),
                    !!(clientData === null || clientData === void 0 ? void 0 : clientData.turtle) &&
                        (clientData === null || clientData === void 0 ? void 0 : clientData.turtle) &&
                        ((_c = clientData === null || clientData === void 0 ? void 0 : clientData.turtle) === null || _c === void 0 ? void 0 : _c.name) !== "" && (React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "Turtle", data: clientData === null || clientData === void 0 ? void 0 : clientData.turtle }))),
                    !!(clientData === null || clientData === void 0 ? void 0 : clientData.cdd) &&
                        (clientData === null || clientData === void 0 ? void 0 : clientData.cdd) &&
                        ((_d = clientData === null || clientData === void 0 ? void 0 : clientData.cdd) === null || _d === void 0 ? void 0 : _d.name) !== "" && (React.createElement(Col, { className: "px-0" },
                        React.createElement(Clientprofilecard, { employeecode: 0, sincetime: "", designation: "CDD", data: clientData === null || clientData === void 0 ? void 0 : clientData.cdd }))))),
            React.createElement(Row, { className: "mx-0 eliteprogram-block px-0 section-padding", id: "elliance-program" },
                React.createElement(EliteProgram, { elliancepatner: clientData === null || clientData === void 0 ? void 0 : clientData.elliancePartner, acquiredprogram: clientData === null || clientData === void 0 ? void 0 : clientData.elliancePartnerAcquired, patnercode: clientData === null || clientData === void 0 ? void 0 : clientData.elliancePartnerCode })),
            React.createElement(Row, { id: "relationship-history", className: "section-padding" },
                React.createElement(RelationShipHistory, null)))))));
};
export default ClientOwners;
